<div class="loader-container">
  <img src="assets/32x32/coditas2.gif" class="loader-logo" loading="lazy" />
</div>
